import {useDispatch, useSelector} from "react-redux";
import React, {useCallback, useEffect} from "react";
import {loadBrandDayInfo} from "../../../../redux/slices/dynamicMultipleElementsSlice";
import ComponentLoader, {ComponentError, ComponentNoData} from "../../../../components/ComponentLoader";
import {safeImage} from "../../../../helpers/helperFunctions";
import {IMAGE_SIZE} from "../../../../constants/commons";

const BrandDay = ({section, mobile = false}) => {
  const {[section.value]: brandDay} =
    useSelector((state) => state.dynamicMultipleElements.brandDay);

  return (
    <MemoizedBrandDayContent brandDay={brandDay} section={section} mobile={mobile}/>
  );
};

export default React.memo(BrandDay);

const BrandDayContents = ({brandDay: {loading, data, init = false, error} = {}, section, mobile}) => {

  const dispatch = useDispatch();
  //
  const fetchBrandDayInfo = useCallback(() => {
    dispatch(loadBrandDayInfo(section.value));
  }, [section, dispatch]);
  //
  useEffect(() => {
    if (!init && !loading && !error)
      fetchBrandDayInfo();
  }, [fetchBrandDayInfo, init, loading, error]);

  return (
    <div className="w-full app-top-mg app-side-pd">
      {
        error ? <ComponentError errorMsg={error} retry={fetchBrandDayInfo}/>
          : loading ? <ComponentLoader/>
            : init && data?.id ?
              <>
                <img src={safeImage(mobile ? data.banner : data.banner_web, IMAGE_SIZE[mobile ? '1024' : '1920'])}
                     alt={data.name} className={`w-full ${mobile ? "app-rounded" : "app-rounded"} shadow-md`}/>
              </>
              : <ComponentNoData/>
      }
    </div>
  );
};


const MemoizedBrandDayContent = React.memo(BrandDayContents);